<template>
  <!-- Main Sidebar -->
  <a-layout-sider collapsible class="sider-primary" breakpoint="lg" collapsed-width="0" width="250px"
    :collapsed="sidebarCollapsed" @collapse="$emit('toggleSidebar', !sidebarCollapsed)" :trigger="null" :class="[
      'ant-layout-sider-' + sidebarColor,
      'ant-layout-sider-' + sidebarTheme
    ]" theme="light" :style="{ backgroundColor: 'transparent' }">
    <div class="brand">
      <img src="images/logo-ct-black.png" alt="" /> <span>PGVIM</span>
    </div>
    <hr />

    <!-- Sidebar Navigation Menu -->
    <a-menu theme="light" mode="inline">
      <!-- Booking -->
      <a-menu-item class="menu-item-header"> Menu </a-menu-item>
      <a-menu-item>
        <router-link to="/dashboard-user">
          <span class="icon" style="padding-left: 10px">
            <a-icon type="calendar" />
          </span>
          <span class="label">Dashboard</span>
        </router-link>
      </a-menu-item>
      <a-menu-item>
        <router-link to="/booking">
          <span class="icon" style="padding-left: 10px">
            <a-icon type="calendar" />
          </span>
          <span class="label">Booking</span>
        </router-link>
      </a-menu-item>

      <a-divider />

      <!-- Logout -->
      <a-menu-item @click="onLogout">
        <div style="padding-left: 15px">
          <span class="icon" style="padding-left: 10px">
            <a-icon type="logout" />
          </span>
          <span class="label">Logout</span>
        </div>
      </a-menu-item>
    </a-menu>
  </a-layout-sider>
</template>

<script>
import tools from "../../utils/tools";

export default {
  props: {
    // Sidebar collapsed status.
    sidebarCollapsed: {
      type: Boolean,
      default: false
    },

    // Main sidebar color.
    sidebarColor: {
      type: String,
      default: "primary"
    },

    // Main sidebar theme : light, white, dark.
    sidebarTheme: {
      type: String,
      default: "light"
    }
  },
  //
  //
  //
  data() {
    return {
      // sidebarCollapsedModel: this.sidebarCollapsed,
    };
  },
  //
  //
  //
  methods: {
    onLogout() {
      localStorage.clear();
      this.$router.push("/login");
    }
  },
  //
  //
  //
  beforeCreate() {
    if (!tools.isLogin()) this.$router.push("/login");
  },
  //
  //
  //
  created() { },
  //
  //
  //
  beforeMounted() { },
  //
  //
  //
  mounted() { },
  //
  //
  //
  beforeUpdated() { },
  //
  //
  //
  updated() { },
  //
  //
  //
  beforeDestroy() { },
  //
  //
  //
  destroyed() { }
};
</script>
